import Vue from 'vue'
import VueRouter from 'vue-router'
import View from '../views/View.vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import numeral from 'numeral';

Vue.filter("formatNumber", function (value) {
    return numeral(value).format('0,0')
});

Vue.use(VueRouter)
Vue.use(VueMaterial)

const routes = [
    {
        path: '/add',
        name: 'Add',
        component: () => import(/* webpackChunkName: "about" */ '../views/Add.vue'),
        meta: {
            title: '깨알퀴즈:'
        }
    }, {
        path: '/',
        name: 'View',
        component: View,
        meta: {
            title: '깨알퀴즈:'
        }
    }, {
        path: '/:id',
        name: 'View',
        component: View,
        meta: {
            title: '깨알퀴즈:'
        }
    }
]

const router = new VueRouter({
    routes
})

export default router
